import { IConvertedImages } from '../interface/IConvertedImages';

export interface IRankingState {
  title?: string;
  url?: string;
  isError: boolean;
  list?: Array<{
    rankingNumber: number;
    headline: string;
    mediaName: string;
    newsLink: string;
    isPay: boolean;
    hasVideo: boolean;
    duration?: string;
    thumb: {
      width: number;
      height: number;
      url: string;
    };
    resizedThumbUrl: IConvertedImages | null;
    dateString: string;
    timeString: string;
  }>;
}
const initialState: IRankingState = {
  title: '',
  url: '',
  isError: true,
  list: []
};

export default (state: IRankingState = initialState) => {
  return state;
};
